export function validateName(name) {
    if (!name.trim())
        return 'Name is required';
    if (name.trim().length < 2)
        return 'Name must be at least 2 characters';
    if (name.trim().length > 64)
        return 'Name is too long';
    if (!/^[a-zA-Z0-9 _-]+$/.test(name.trim()))
        return 'Name contains invalid characters';
    return null;
}
export function validateCredits(value) {
    const num = Number(value);
    if (isNaN(num))
        return 'Must be a number';
    if (!Number.isInteger(num))
        return 'Must be an integer';
    if (num < 0)
        return 'Cannot be negative';
    return null;
}
export function validateDelta(value) {
    const num = Number(value);
    if (isNaN(num))
        return 'Must be a number';
    if (!Number.isInteger(num))
        return 'Must be an integer';
    if (num === 0)
        return 'Cannot be zero';
    return null;
}
export function validateEmail(email) {
    if (!email.trim())
        return 'Email is required';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
        return 'Invalid email';
    return null;
}
export function validatePassword(password) {
    if (!password)
        return 'Password is required';
    if (password.length < 8)
        return 'Password must be at least 8 characters';
    return null;
}
